import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// ── Query key factories ──

interface ListKeyFilters {
  search?: string;
  status?: string;
  sort?: string;
  sortDir?: string;
}

export const userKeys = {
  all: ["users"] as const,
  list: (filters?: { search?: string }) => ["users", "list", filters] as const,
} as const;

export const devKeys = {
  seedAccounts: ["dev", "seed-accounts"] as const,
} as const;

export const auditKeys = {
  all: ["audit"] as const,
  list: (filters: ListKeyFilters) => ["audit", "list", filters] as const,
} as const;

export const waypointSessionKeys = {
  all: ["waypoint-sessions"] as const,
  list: () => ["waypoint-sessions", "list"] as const,
  history: (params: object) => ["waypoint-sessions", "history", params] as const,
  detail: (id: string) => ["waypoint-sessions", "detail", id] as const,
  profile: () => ["waypoint-sessions", "profile"] as const,
} as const;
